export default class ImageOverVideo {
    constructor() {
        /*
     image-over-video-js
       used by full-image panel

       markup should include img & player div/iframe:
         <img class="fullimage-image video-cover js-image-over-video"
             data-video-player="video-{{panel.ID}}"
             src="{{TimberImage(panel.fullimage).src}}" alt=""
         />
         <div class="video-{{panel.ID}}" style="display:none;">
            <iframe data-video-id="{{panel.youtube_id}}" allowfullscreen></iframe>
         </div>

     */
        if ($('.js-image-over-video').length) {
            if (!!(window.OptanonActiveGroups && window.OptanonActiveGroups.indexOf('C0004') >= 0)) {
                $('.js-image-over-video').on('click', function onClick() {
                    const $this = $(this);
                    // console.log($this);
                    const $parent = $this.closest('.video-container');
                    const $player = $(`.${$this.data('video-player')}`);
                    const $iframe = $player.find('iframe');
                    const vidid = $iframe.data('video-id');

                    // add youtube url w/autoplay to iframe
                    $iframe.attr('src', `//www.youtube.com/embed/${vidid}?enablejsapi=1&autoplay=1&rel=0`);
                    $player.show();
                    // console.log($parent);
                    $parent.addClass('video-active');

                    // hide image
                    $this.hide();

                    return false;
                });
            } else {
                $('.consent-message').removeClass('hidden');
            }
        }

        $('.js-image-over-video-native').on('click', function onClick() {
            const $this = $(this);
            const $parent = $this.closest('.video-container');
            const $player = $parent.find('video');

            $this.fadeOut('fast', () => {
                $player[0].play();
            });

            return false;
        });
    }
}
